

























































import _ from "lodash";
import { Prop, Component, Vue } from "vue-property-decorator";
import ScheduleEventApi from "../../../api/schedule/schedule-event-api";
import { client } from "../../../api/request";
import { Project, getAssignedProjects } from "../../../api/project-api";
import ScheduleEventSaveRequest from "../../../schedule/usecases/schedule-event-save-request";
import formatTime from "../../../helpers/formatTime";
import ProjectOption from "@/ui/common/presenters/project-option";
import formatLocaleDate from "@/helpers/formatLocaleDate";

const eventApi = new ScheduleEventApi(client);

// TODO パーミッションがないと開けないようにする
@Component({})
export default class EditScheduleEventModal extends Vue {
  @Prop({ type: Boolean }) projectEditable!: boolean;

  public async show(id: number) {
    await this.init(id);
    this.$nextTick(() => {
      (this.$refs.modal as any).show();
    });
  }

  public hide() {
    (this.$refs.modal as any).hide();
  }

  date = new Date();
  // TODO コンストラクタにまとめる
  event: ScheduleEventSaveRequest = {
    projectId: 0,
    title: "",
    description: "",
    date: new Date(),
    startTime: "00:00",
    endTime: "00:00"
  };

  get heading() {
    return formatLocaleDate(this.event.date);
  }

  // TODO ViewModelにまとめる
  get projectOptions(): ProjectOption[] {
    return this.projects.map(p => new ProjectOption(p));
  }

  async save() {
    await eventApi.save(this.event);
    this.$emit("ok");
    this.hide();
  }

  async destroy() {
    if (!confirm("本当に予定を削除しますか？")) return;
    await eventApi.delete(this.event.id!);
    this.$emit("ok");
    this.hide();
  }

  protected mounted() {
    this.initProjectList();
  }

  private async init(id: number) {
    const event = await eventApi.find(id);
    if (!event) {
      throw new Error("event is not found");
    }
    this.event = {
      ...event,
      date: event.start,
      startTime: formatTime(event.start),
      endTime: formatTime(event.end)
    };
  }

  private projects: Project[] = [];

  private async initProjectList() {
    this.projects = _.orderBy(await getAssignedProjects(), "created", "desc");
  }
}
